import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row my-2" }
const _hoisted_3 = { class: "container col-sm col-md-8" }
const _hoisted_4 = { class: "row justify-content-end mt-2" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "col-2 summary-col" }
const _hoisted_7 = { class: "wrap-text" }
const _hoisted_8 = { class: "col-5 summary-col" }
const _hoisted_9 = { class: "wrap-text" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "col-5 summary-col align-self-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      here: `${_ctx.branchName}支店の差分概要`,
      ancestries: _ctx.ancestries
    }, null, 8, ["here", "ancestries"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
      }, _toDisplayString(_ctx.branchName) + "支店の配布記録データ差分概要", 5)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, "更新日時：" + _toDisplayString(_ctx.updatedDTString()), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row table-header-row" }, [
          _createElementVNode("div", { class: "col-2" }, "ID"),
          _createElementVNode("div", { class: "col-5" }, "スタッフ"),
          _createElementVNode("div", { class: "col-5" }, "差分概要")
        ], -1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branchDiffSummary.entities, (staffDiff) => {
          return (_openBlock(), _createElementBlock("div", {
            key: staffDiff.vForKey,
            class: "row summary-row"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(staffDiff.staffId), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                (staffDiff.hasDiff)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _withModifiers(($event: any) => (_ctx.onClickStaffDiffSummary(staffDiff.staffId, staffDiff.name)), ["prevent"]),
                      href: "#"
                    }, _toDisplayString(staffDiff.name), 9, _hoisted_10))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(staffDiff.name), 1)
                    ], 64))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'added': staffDiff.added > 0}])
              }, "追加：" + _toDisplayString(staffDiff.added), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'changed': staffDiff.changed > 0}])
              }, "変更：" + _toDisplayString(staffDiff.changed), 3),
              _createElementVNode("p", {
                class: _normalizeClass(["diff-text", {'deleted': staffDiff.deleted > 0}])
              }, "削除：" + _toDisplayString(staffDiff.deleted), 3)
            ])
          ]))
        }), 128))
      ])
    ])
  ], 64))
}